import { render } from 'react-dom'
import React, { Suspense } from 'react'
import { Canvas } from 'react-three-fiber'
import { useProgress, Html } from '@react-three/drei'
import { HashRouter as Router } from 'react-router-dom'
import TagManager from 'react-gtm-module'

import Scene1 from './Scene1'

import "./base.css"

const tagManagerArgs = {
  gtmId: 'GTM-T6W2V4J'
}

TagManager.initialize(tagManagerArgs);

function Loader() {
  const { progress } = useProgress()
  return (
    <Html center>
      <span style={{ color: '#FFFFFF' }}>{progress} % loaded</span>
    </Html>
  )
}

function App(props) {
  const { scene = 1 } = props
  let res = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  let fov = 60
  if(res < 1280) {
    fov = 95
  }
  return (
    <Canvas concurrent shadowMap camera={{ position: [0, 0, 5], fov: fov }}>
      <color attach="background" args={['#000']} />
      <Suspense fallback={<Loader />}>
        {scene === 1 && <Scene1 />}
      </Suspense>
      <ambientLight intensity={0.7} />
    </Canvas>
  )
}

function Body() {
  return (
    <Router>
      <main>

        <div className="frame">
          <div className="frame__title-wrap">
            <span className="frame__title">COMING SOON</span>            
          </div>
          <div className="frame__links">
            <span><a href="mailto:info@horama.it">info@horama.it</a></span><br/><span className="frame__tagline"><a href="tel:00393515936077">+39 351 5936 077</a></span>
          </div>
          <div className="frame__demos">
          <span className="only-mobile two">COMING SOON</span>
           <span className="opacity-mobile">Horama s.r.l.<br/>via Enrico Fermi, 70 - 38123 Trento</span> <span className="only-mobile opacity-mobile"> P.IVA 02643790229</span>
          </div>       
          <div className="frame__soon">
          P.IVA 02643790229
          </div>      
        </div>

        <div className="content">
          <App scene={1} />
        </div>
      </main>
    </Router>
  )
}

render(<Body />, document.querySelector('#root'))
